import { Grid, makeStyles } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import { FieldDef } from "../typeConfig";

type Props = {
  fields: FieldDef[];
};

export default function FieldCardSkeleton({ fields }: Props) {
  const classes = useStyles();

  return (
    <Grid container spacing={2} className={classes.grid}>
      {fields.map(field => (
        <Grid item xs={12} md={6} key={field.key}>
          <Skeleton
            variant="rect"
            className={classes.skeleton}
            style={{ height: "100%", minHeight: field.kind === "layout" ? 140 : 80 }}
          />
        </Grid>
      ))}
    </Grid>
  );
}

const useStyles = makeStyles(() => ({
  grid: {
    marginTop: 8,
  },
  skeleton: {
    borderRadius: 8,
  },
}));
